import { Component, Input } from '@angular/core';
import { Document } from '../../../../../beans/health-record/other-documents.bean';

@Component({
	selector: 'app-upload-viewer',
	templateUrl: './upload-viewer.component.html',
	styleUrls: ['./upload-viewer.component.scss'],
})
export class UploadViewerComponent {
	@Input() document: Document;
}
